import axios from 'axios'
import {
  Message
} from 'element-ui'
import {getToken} from '@/utils/auth'

// export function getBaseUrl() {
//   switch (process.env.NODE_ENV) {
//     case 'production':
//       return 'https://mango.gaogell.com' //生产环境url
//     default:
//       return process.env.NODE_ENV
//   }
// }

// create an axios instance
const service = axios.create({
  baseURL: process.env.BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  },
  timeout: 30000
})

// request interceptor
service.interceptors.request.use(config => {
  if (getToken()) {
    config.headers['token'] = getToken()
  }
  console.log(config.url)
  if (config.params) {
    console.log(config.params)
  } else if (config.data) {
    console.log(config.data)
  }
  return config
}, error => {
  console.log(error)
  return Promise.reject(error)
})

service.interceptors.response.use(response => {
  const res = response.data
  console.log(res)
  if (res.code !== 1000) {
    if (res.code === 50403 || res.code === 50400) {
      return res
    }
    Message({
      message: res.msg || res.message || 'Error', type: 'error', duration: 5 * 1000
    })
    return Promise.reject(res)
  } else {
    return res
  }
}, error => {
  console.log('err' + error) // for debug
  Message({
    message: error, type: 'error', duration: 5 * 1000
  })
  return Promise.reject(error)
})

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js